import React, { useState, useEffect } from "react";
import Footer from "../components/Footer";

const PackagesPricingPage: React.FC = () => {
  const [selectedCountry, setSelectedCountry] = useState<string>("nigeria");
  const [activeTab, setActiveTab] = useState<string>("second");

  useEffect(() => {
    // Load Flutterwave script
    const script = document.createElement("script");
    script.src = "https://checkout.flutterwave.com/v3.js";
    script.async = true;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const showPrice = (country: string) => {
    setSelectedCountry(country);
  };

  const showStyle = (style: string) => {
    setActiveTab(style);
  };

  const makePayment = (
    txRef: string,
    amount: number,
    currency: string,
    page: string,
  ) => {
    const enterEmail = window.prompt("Please Enter email:");
    if (enterEmail && (window as any).FlutterwaveCheckout) {
      (window as any).FlutterwaveCheckout({
        public_key: "FLWPUBK-5f6838a7c0e57abef40cddf34c449086-X",
        tx_ref: txRef,
        amount,
        currency,
        payment_options: "card, banktransfer, ussd",
        redirect_url: `https://stemcafe.io/${page}.html`,
        customer: {
          email: enterEmail,
        },
      });
    }
  };

  return (
    <div>
      <div id="packages" className="p60">
        <div className="container">
          <div className="page-header">
            <h2>Packages</h2>
            <p>
              Choose any of the following monthly plans which allow kids have
              access to the cafe at huge discounts.
            </p>

            <div className="row head">
              <div className="col-sm-5">
                <p>Showing membership packages for</p>
              </div>
              <div className="col-sm-7">
                <button
                  onClick={() => {
                    showStyle("first");
                    showPrice("kenya");
                  }}
                  id="first"
                  className={activeTab === "first" ? "active" : "unactive"}
                >
                  Kenya
                </button>
                <button
                  onClick={() => {
                    showStyle("second");
                    showPrice("nigeria");
                  }}
                  id="second"
                  className={activeTab === "second" ? "active" : "unactive"}
                >
                  Nigeria
                </button>
                <button
                  onClick={() => {
                    showStyle("third");
                    showPrice("rwanda");
                  }}
                  id="third"
                  className={activeTab === "third" ? "active" : "unactive"}
                >
                  Rwanda
                </button>
                <button
                  onClick={() => {
                    showStyle("fourth");
                    showPrice("portHarcout");
                  }}
                  id="fourth"
                  className={activeTab === "fourth" ? "active" : "unactive"}
                >
                  Port Harcourt
                </button>
              </div>
            </div>
          </div>
          {selectedCountry === "portHarcout" && (
            <div id="portHarcout" className="package-grid">
              <div className="light-blue-border">
                <h3>Unlimited Maker Pass - 5 days</h3>
                <p>Up to 4 hours daily • 5 days</p>
                <p className="plan-cost">
                  NGN 147,187 <span>monthly/child</span>{" "}
                </p>

                {/*
                    <!-- <a href="https://rave.flutterwave.com/pay/rulgjy8mhqx6" target="_blank">Get package</a> -->
                    */}
                <button
                  type="button"
                  id="start-payment-button"
                  onClick={() => {
                    makePayment(
                      "Unlimited Maker Pass - 5 days",
                      147187,
                      "NGN",
                      "packages",
                    );
                  }}
                >
                  Get package
                </button>
              </div>
              <div className="red-border">
                <h3>Unlimited Maker Pass - 3 days</h3>
                <p>Up to 4 hours daily • 3 days</p>
                <p className="plan-cost">
                  NGN 109,864 <span>monthly/child</span>{" "}
                </p>

                {/*<!-- <a href="https://rave.flutterwave.com/pay/rulgjy8mhqx6" target="_blank">Get package</a> -->*/}
                <button
                  type="button"
                  id="start-payment-button"
                  onClick={() => {
                    makePayment(
                      "Unlimited Maker Pass - 3 days",
                      109864,
                      "NGN",
                      "packages",
                    );
                  }}
                >
                  Get package
                </button>
              </div>
              <div className="green-border">
                <h3>After-School Pass - 5 days</h3>
                <p>
                  Mondays - Fridays • Up to 2 hours daily • 5 days • All ages
                </p>
                <p className="plan-cost">
                  NGN 70,026 <span>monthly/child</span>{" "}
                </p>
                <button
                  type="button"
                  id="start-payment-button"
                  onClick={() => {
                    makePayment(
                      "After-School Pass - 5 days",
                      70026,
                      "NGN",
                      "packages",
                    );
                  }}
                >
                  Get package
                </button>
              </div>
              <div className="yellow-border">
                <h3>After-School Pass - 3 days</h3>
                <p>
                  Mondays - Fridays • Up to 2 hours daily • 3 days • All ages
                </p>
                <p className="plan-cost">
                  NGN 61,678 <span>monthly/child</span>{" "}
                </p>
                <button
                  type="button"
                  id="start-payment-button"
                  onClick={() => {
                    makePayment(
                      "After-School Pass - 3 days",
                      61678,
                      "NGN",
                      "packages",
                    );
                  }}
                >
                  Get package
                </button>
              </div>
              <div className="purple-border">
                <h3>Weekend Explorer</h3>
                <p>Saturdays • Up to 3 hours daily • 7-18 years</p>
                <p className="plan-cost">
                  NGN 40,635 <span>per month/child</span>{" "}
                </p>
                <button
                  type="button"
                  id="start-payment-button"
                  onClick={() => {
                    makePayment("Weekend Explorer", 40635, "NGN", "packages");
                  }}
                >
                  Get package
                </button>
              </div>
              <div className="amber-border">
                <h3>Weekend Explorer Lite</h3>
                <p>Saturdays • Up to 3 hours • 5 and 6 years</p>
                <p className="plan-cost">
                  NGN 30,476 <span>per month/child</span>{" "}
                </p>
                <button
                  type="button"
                  id="start-payment-button"
                  onClick={() => {
                    makePayment(
                      "Weekend Explorer Lite",
                      30476,
                      "NGN",
                      "packages",
                    );
                  }}
                >
                  Get package
                </button>
              </div>
              )
            </div>
          )}
          {selectedCountry === "nigeria" && (
            <div id="nigeria" className="package-grid">
              <div className="green-border">
                <h3>Unlimited Maker Pass - 5 days</h3>
                <p>Up to 8 hours daily • 5 days</p>
                <p className="plan-cost">
                  NGN 209,525 <span>monthly/child</span>
                </p>
                <button
                  type="button"
                  onClick={() =>
                    makePayment(
                      "Unlimited Maker Pass - 5 days",
                      209525,
                      "NGN",
                      "packages",
                    )
                  }
                >
                  Get package
                </button>
              </div>

              <div className="brown-border">
                <h3>Unlimited Maker Pass - 3 days</h3>
                <p>Up to 8 hours daily • 3 days</p>
                <p className="plan-cost">
                  NGN 151,062 <span>monthly/child</span>
                </p>
                <button
                  type="button"
                  onClick={() =>
                    makePayment(
                      "Unlimited Maker Pass - 3 days",
                      151062,
                      "NGN",
                      "packages",
                    )
                  }
                >
                  Get package
                </button>
              </div>

              <div className="yellow-border">
                <h3>After-School Pass - 5 days</h3>
                <p>
                  Mondays - Fridays • Up to 2 hours daily • 5 days • All ages
                </p>
                <p className="plan-cost">
                  NGN 99,511 <span>monthly/child</span>
                </p>
                <button
                  type="button"
                  onClick={() =>
                    makePayment(
                      "After-School Pass - 5 days",
                      99511,
                      "NGN",
                      "packages",
                    )
                  }
                >
                  Get package
                </button>
              </div>

              <div className="amber-border">
                <h3>After-School Pass - 3 days</h3>
                <p>
                  Mondays - Fridays • Up to 2 hours daily • 3 days • All ages
                </p>
                <p className="plan-cost">
                  NGN 83,265 <span>monthly/child</span>
                </p>
                <button
                  type="button"
                  onClick={() =>
                    makePayment(
                      "After-School Pass - 3 days",
                      83265,
                      "NGN",
                      "packages",
                    )
                  }
                >
                  Get package
                </button>
              </div>

              <div className="green-border">
                <h3>Weekend Explorer (Exploratory Or Intermediate)</h3>
                <p>Saturdays • Up to 3 hours daily • 7-18 years</p>
                <p className="plan-cost">
                  NGN 56,899 <span>per month/child</span>
                </p>
                <button
                  type="button"
                  onClick={() =>
                    makePayment("Weekend Explorer", 56899, "NGN", "packages")
                  }
                >
                  Get package
                </button>
              </div>

              <div className="green-border">
                <h3>Weekend Explorer (Advanced)</h3>
                <p>Saturdays • Up to 3 hours daily • 7-18 years</p>
                <p className="plan-cost">
                  NGN 60,953 <span>per month/child</span>
                </p>
                <button
                  type="button"
                  onClick={() =>
                    makePayment("Weekend Explorer", 60953, "NGN", "packages")
                  }
                >
                  Get package
                </button>
              </div>

              <div className="blue-border">
                <h3>Weekend Explorer Lite (Exploratory Or Intermediate)</h3>
                <p>Saturdays • Up to 3 hours • 5 and 6 years</p>
                <p className="plan-cost">
                  NGN 42,666 <span>per month/child</span>
                </p>
                <button
                  type="button"
                  onClick={() =>
                    makePayment(
                      "Weekend Explorer Lite",
                      42666,
                      "NGN",
                      "packages",
                    )
                  }
                >
                  Get package
                </button>
              </div>

              <div className="blue-border">
                <h3>Weekend Explorer Lite (Advanced)</h3>
                <p>Saturdays • Up to 3 hours • 5 and 6 years</p>
                <p className="plan-cost">
                  NGN 45,714 <span>per month/child</span>
                </p>
                <button
                  type="button"
                  onClick={() =>
                    makePayment(
                      "Weekend Explorer Lite Advanced",
                      45714,
                      "NGN",
                      "packages",
                    )
                  }
                >
                  Get package
                </button>
              </div>
            </div>
          )}

          {/* Weekly Plans Section for Nigeria */}
          {selectedCountry === "nigeria" && (
            <div className="p60">
              <div className="page-header">
                <h2>Weekly Plans</h2>
                <p>
                  Choose any of the following weekly plans which allow kids have
                  all-day access to the cafe at huge discounts.
                </p>
              </div>
              <ul className="weeklyplans-grid">
                <li>
                  <div className="daily">
                    <p>Hourly</p>
                    <hr />
                    <span>NGN</span>
                    <h5>10,320</h5>
                    <span>per child</span>
                  </div>
                </li>
                <li>
                  <div>
                    <p>1 day</p>
                    <hr />
                    <span>NGN</span>
                    <h5>22,596</h5>
                    <span>per child</span>
                  </div>
                </li>
                <li>
                  <div>
                    <p>2 days</p>
                    <hr />
                    <span>NGN</span>
                    <h5>38,632</h5>
                    <span>per child</span>
                  </div>
                </li>
              </ul>
            </div>
          )}
          {selectedCountry === "rwanda" && (
            <div id="rwanda" className="package-grid">
              <div className="orange-border">
                <h3>Unlimited Maker Pass</h3>
                <p>Up to 4 hours daily • Everyday of the week</p>
                <p className="plan-cost">
                  RWF 140,430 <span>monthly/child</span>{" "}
                </p>
                <button
                  type="button"
                  id="start-payment-button"
                  onClick={() => {
                    makePayment(
                      "Unlimited Maker Pass",
                      140430,
                      "RWF",
                      "packages",
                    );
                  }}
                >
                  Get package
                </button>
              </div>

              <div className="amber-border">
                <h3>After-School Pass</h3>
                <p>
                  Mondays - Fridays • Up to 2 hours daily for 3 times a week •
                  All ages
                </p>
                <p className="plan-cost">
                  RWF 105,290 <span>monthly/child</span>{" "}
                </p>
                <button
                  type="button"
                  id="start-payment-button"
                  onClick={() => {
                    makePayment("After-School Pass", 105290, "RWF", "packages");
                  }}
                >
                  Get package
                </button>
              </div>

              <div className="green-border">
                <h3>Weekend Explorer</h3>
                <p>Saturdays • Up to 4 hours daily • 7-18 years</p>
                <p className="plan-cost">
                  RWF 61,500 <span>6 weeks/child</span>{" "}
                </p>
                <button
                  type="button"
                  id="start-payment-button"
                  onClick={() => {
                    makePayment("Weekend Explorer", 61500, "RWF", "packages");
                  }}
                >
                  Get package
                </button>
              </div>

              <div className="blue-border">
                <h3>Weekend Explorer Lite</h3>
                <p>Saturdays • Up to 3 hours • 5 and 6 years</p>
                <p className="plan-cost">
                  RWF 46,130 <span>6 weeks/child</span>{" "}
                </p>
                <button
                  type="button"
                  id="start-payment-button"
                  onClick={() => {
                    makePayment(
                      "Weekend Explorer Lite",
                      46130,
                      "RWF",
                      "packages",
                    );
                  }}
                >
                  Get package
                </button>
              </div>

              <div className="purple-border">
                <h3>Bulk Plan Purchase</h3>
                <p>10 hours and above • All ages</p>
                <p className="plan-cost">
                  RWF 4680 <span>1 hour/child</span>{" "}
                </p>
                <button
                  type="button"
                  id="start-payment-button"
                  onClick={() => {
                    makePayment("Bulk Plan Purchase", 4680, "RWF", "packages");
                  }}
                >
                  Get package
                </button>
              </div>

              <div className="brown-border">
                <h3>School Pass</h3>
                <p>Monday - Friday • 10 kids • 2 hours. All ages </p>
                <p className="plan-cost">
                  RWF 7500 <span> / per child</span>{" "}
                </p>
                <button
                  type="button"
                  id="start-payment-button"
                  onClick={() => {
                    makePayment("School Pass", 7500, "RWF", "packages");
                  }}
                >
                  Get package
                </button>
              </div>

              <div className="yellow-border">
                <h3>Customized</h3>
                <p>Monday - Friday • 2 days • 4 hours • All ages </p>
                <p className="plan-cost">
                  RWF 96,930 <span>monthly/child</span>{" "}
                </p>
                <button
                  type="button"
                  id="start-payment-button"
                  onClick={() => {
                    makePayment("Customized", 96930, "RWF", "packages");
                  }}
                >
                  Get package
                </button>
              </div>
            </div>
          )}
          {selectedCountry === "kenya" && (
            <div id="kenya" className="package-grid">
              <div className="orange-border">
                <h3>Scratch Programming- Exploratory module</h3>
                <p>6 Sessions</p>
                <p className="plan-cost">
                  KES 7,280 <span>monthly/child</span>{" "}
                </p>
                <button
                  type="button"
                  id="start-payment-button"
                  onClick={() => {
                    makePayment(
                      "Scratch Programming- Exploratory module",
                      7280,
                      "KES",
                      "packages",
                    );
                  }}
                >
                  Get package
                </button>
              </div>

              <div className="amber-border">
                <h3>Scratch Programming- Intermediate module</h3>
                <p>6 Sessions</p>
                <p className="plan-cost">
                  KES 8,866 <span>monthly/child</span>{" "}
                </p>
                <button
                  type="button"
                  id="start-payment-button"
                  onClick={() => {
                    makePayment(
                      "Scratch Programming- Intermediate module",
                      8866,
                      "KES",
                      "packages",
                    );
                  }}
                >
                  Get package
                </button>
              </div>

              <div className="purple-border">
                <h3>Scratch Programming- Advanced module</h3>
                <p>6 Sessions</p>
                <p className="plan-cost">
                  KES 8,866 <span>monthly/child</span>{" "}
                </p>
                <button
                  type="button"
                  id="start-payment-button"
                  onClick={() => {
                    makePayment(
                      "Scratch Programming- Advanced module",
                      8866,
                      "KES",
                      "packages",
                    );
                  }}
                >
                  Get package
                </button>
              </div>

              <div className="green-border">
                <h3>3D Modelling and Design- Exploratory module</h3>
                <p>6 Sessions</p>
                <p className="plan-cost">
                  KES 7,280 <span>monthly/child</span>{" "}
                </p>
                <button
                  type="button"
                  id="start-payment-button"
                  onClick={() => {
                    makePayment(
                      "3D Modelling and Design- Exploratory module",
                      7280,
                      "KES",
                      "packages",
                    );
                  }}
                >
                  Get package
                </button>
              </div>

              <div className="blue-border">
                <h3>3D Modelling and Design- Intermediate module</h3>
                <p>6 Sessions</p>
                <p className="plan-cost">
                  KES 8,866 <span>monthly/child</span>{" "}
                </p>
                <button
                  type="button"
                  id="start-payment-button"
                  onClick={() => {
                    makePayment(
                      "3D Modelling and Design- Intermediate module",
                      8866,
                      "KES",
                      "packages",
                    );
                  }}
                >
                  Get package
                </button>
              </div>

              <div className="brown-border">
                <h3>3D Modelling and Design- Advanced module</h3>
                <p>6 Sessions</p>
                <p className="plan-cost">
                  KES 8,866 <span>monthly/child</span>{" "}
                </p>
                <button
                  type="button"
                  id="start-payment-button"
                  onClick={() => {
                    makePayment(
                      "3D Modelling and Design- Advanced module",
                      8866,
                      "KES",
                      "packages",
                    );
                  }}
                >
                  Get package
                </button>
              </div>

              <div className="yellow-border">
                <h3>Physical computing with Arduino- Exploratory module</h3>
                <p>8 Sessions</p>
                <p className="plan-cost">
                  KES 9,100 <span>monthly/child</span>{" "}
                </p>
                <button
                  type="button"
                  id="start-payment-button"
                  onClick={() => {
                    makePayment(
                      "Physical computing with Arduino- Exploratory module",
                      9100,
                      "KES",
                      "packages",
                    );
                  }}
                >
                  Get package
                </button>
              </div>

              <div className="red-border">
                <h3>Physical computing with Arduino- Intermediate module</h3>
                <p>8 Sessions</p>
                <p className="plan-cost">
                  KES 9,100 <span>monthly/child</span>{" "}
                </p>
                <button
                  type="button"
                  id="start-payment-button"
                  onClick={() => {
                    makePayment(
                      "Physical computing with Arduino- Intermediate module",
                      9100,
                      "KES",
                      "packages",
                    );
                  }}
                >
                  Get package
                </button>
              </div>

              <div className="light-blue-border">
                <h3>Physical computing with Arduino- Advanced module</h3>
                <p>8 Sessions</p>
                <p className="plan-cost">
                  KES 10,400 <span>monthly/child</span>{" "}
                </p>
                <button
                  type="button"
                  id="start-payment-button"
                  onClick={() => {
                    makePayment(
                      "Physical computing with Arduino- Advanced module",
                      10400,
                      "KES",
                      "packages",
                    );
                  }}
                >
                  Get package
                </button>
              </div>

              <div className="amber-border">
                <h3>Python programming- Exploratory module</h3>
                <p>8 Sessions</p>
                <p className="plan-cost">
                  KES 9,100 <span>monthly/child</span>{" "}
                </p>
                <button
                  type="button"
                  id="start-payment-button"
                  onClick={() => {
                    makePayment(
                      "Python programming- Exploratory module",
                      9100,
                      "KES",
                      "packages",
                    );
                  }}
                >
                  Get package
                </button>
              </div>

              <div className="green-border">
                <h3>Python programming- Intermediate module</h3>
                <p>8 Sessions</p>
                <p className="plan-cost">
                  KES 9,100 <span>monthly/child</span>{" "}
                </p>
                <button
                  type="button"
                  id="start-payment-button"
                  onClick={() => {
                    makePayment(
                      "Python programming- Intermediate module",
                      9100,
                      "KES",
                      "packages",
                    );
                  }}
                >
                  Get package
                </button>
              </div>

              <div className="blue-border">
                <h3>Python programming- Advanced module</h3>
                <p>8 Sessions</p>
                <p className="plan-cost">
                  KES 9,100 <span>monthly/child</span>{" "}
                </p>
                <button
                  type="button"
                  id="start-payment-button"
                  onClick={() => {
                    makePayment(
                      "Python programming- Advanced module",
                      9100,
                      "KES",
                      "packages",
                    );
                  }}
                >
                  Get package
                </button>
              </div>
              <div className="red-border">
                <h3>Science Discovery</h3>
                <p>6 Sessions</p>
                <p className="plan-cost">
                  KES 7,000 <span>monthly/child</span>{" "}
                </p>
                <button
                  type="button"
                  id="start-payment-button"
                  onClick={() => {
                    makePayment("Science Discovery", 7000, "KES", "packages");
                  }}
                >
                  Get package
                </button>
              </div>

              <div className="green-border">
                <h3>Weekend Explorer</h3>
                <p>6 Sessions • 7-18 years</p>
                <p className="plan-cost">
                  KES 12,000 <span>per month/child</span>{" "}
                </p>
                <button
                  type="button"
                  id="start-payment-button"
                  onClick={() => {
                    makePayment("Weekend Explorer", 12000, "KES", "packages");
                  }}
                >
                  Get package
                </button>
              </div>

              <div className="blue-border">
                <h3>Weekend Explorer Lite</h3>
                <p>6 Sessions • 5 and 6 years</p>
                <p className="plan-cost">
                  KES 6,500 <span>per month/child</span>{" "}
                </p>
                <button
                  type="button"
                  id="start-payment-button"
                  onClick={() => {
                    makePayment(
                      "Weekend Explorer Lite",
                      6500,
                      "KES",
                      "packages",
                    );
                  }}
                >
                  Get package
                </button>
              </div>
            </div>
          )}
          {/*Weekly for portHarcout*/}
          {selectedCountry === "portHarcout" && (
            <div className="p60">
              <div className="page-header">
                <h2>Weekly Plans</h2>
                <p>
                  Choose any of the following weekly plans which allow kids to
                  have all-day access to the cafe at huge discounts.
                </p>{" "}
              </div>
              <div id="portHarcout-weekly">
                <ul className="weeklyplans-grid">
                  <li>
                    <div className="daily">
                      <p>Hourly</p>
                      <hr />
                      <span>NGN</span>
                      <h5>5,000</h5>
                      <span>per child</span>
                    </div>
                  </li>
                  <li>
                    <div>
                      <p>1 day</p>
                      <hr />
                      <span>NGN</span>
                      <h5>10,733</h5>
                      <span>per child</span>
                    </div>
                  </li>
                  <li>
                    <div>
                      <p>2 days</p>
                      <hr />
                      <span>NGN</span>
                      <h5>16,998</h5>
                      <span>per child</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/*Weekly plans for kenya*/}
          {selectedCountry === "kenya" && (
            <div className="p60">
              <div className="page-header">
                <h2>Weekly Plans</h2>
                <p>
                  Choose any of the following weekly plans which allow kids have
                  all-day access to the cafe at huge discounts.
                </p>
              </div>
              <ul className="weeklyplans-grid">
                <li>
                  <div>
                    <p>1 day</p>
                    <hr />
                    <span>KES</span>
                    <h5>2,000</h5>
                    <span>per child</span>
                  </div>
                </li>
              </ul>
            </div>
          )}
          {selectedCountry === "rwanda" && (
            <div className="p60">
              <div className="page-header">
                <h2>Weekly Plans</h2>
                <p>
                  Choose any of the following weekly plans which allow kids have
                  all-day access to the cafe at huge discounts.
                </p>
              </div>
              <ul className="weeklyplans-grid">
                <li>
                  <div className="daily">
                    <p>Hourly</p>
                    <hr />
                    <span>RWF</span>
                    <h5>5,200</h5>
                    <span>per child</span>
                  </div>
                </li>
                <li>
                  <div>
                    <p>1 day</p>
                    <hr />
                    <span>RWF</span>
                    <h5>12,900</h5>
                    <span>per child</span>
                  </div>
                </li>
                <li>
                  <div>
                    <p>2 days</p>
                    <hr />
                    <span>RWF</span>
                    <h5>25,800</h5>
                    <span>per child</span>
                  </div>
                </li>
                <li>
                  <div>
                    <p>3 days</p>
                    <hr />
                    <span>RWF</span>
                    <h5>38,700</h5>
                    <span>per child</span>
                  </div>
                </li>
                <li>
                  <div>
                    <p>4 days</p>
                    <hr />
                    <span>RWF</span>
                    <h5>51,600</h5>
                    <span>per child</span>
                  </div>
                </li>
                <li>
                  <div>
                    <p>5 days</p>
                    <hr />
                    <span>RWF</span>
                    <h5>64,500</h5>
                    <span>per child</span>
                  </div>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PackagesPricingPage;
